import PropTypes from "prop-types";

function FunnelSnapshotCard({ allListings, claimed, premium, renewedRate }) {
  const claimPercent =
    allListings > 0
      ? Math.min(Math.round((claimed / allListings) * 100), 100)
      : 0;

  const premiumPercent =
    claimed > 0
      ? Math.min(Math.round((premium / claimed) * 100), 100)
      : 0;

  return (
    <section className="sd-card sd-funnel">
      <h3 className="sd-section-title">Directory Snapshot</h3>

      <div className="sd-funnel__steps">
        <div className="sd-funnel__step">
          <strong>{(allListings ?? 0).toLocaleString()}</strong>
          <span>Listings</span>
        </div>

        <span className="sd-funnel__arrow">&rarr;</span>

        <div className="sd-funnel__step">
          <strong>{(claimed ?? 0).toLocaleString()} Claimed</strong>
          <span>{claimPercent}%</span>
        </div>

        <span className="sd-funnel__arrow">&rarr;</span>

        <div className="sd-funnel__step">
          <strong>{(premium ?? 0).toLocaleString()} Premium</strong>
          <span>{premiumPercent}%</span>
        </div>
      </div>
    </section>
  );
}

FunnelSnapshotCard.propTypes = {
  allListings: PropTypes.number.isRequired,
  claimed: PropTypes.number.isRequired,
  premium: PropTypes.number.isRequired,
  renewedRate: PropTypes.number,
};

export default FunnelSnapshotCard;